import React from 'react';
import './styles.scss';
interface Props {
  labelText: string;
  unit: string;
  inputValue: string;
  onChange: any;
  error: boolean;
  isDisabled?: boolean;
  id?: string;
}

function InputWithUnit(props: Props) {
  const { labelText, unit, inputValue, onChange, error, isDisabled, id } = props;
  return (
    <div
      id="inputwithunit-wrapper"
      className={`flex flex-column flex-space-between unit-box-container align-items-start`}
    >
      <label
        id={`inputwithunit-wrapper-label-${labelText}`}
        className="ei-label gridlayer-label pb-2"
      >
        {labelText}
      </label>
      <div
        id={`inputwithunit-container`}
        className={`flex unit-box-input-text-container ${
          isDisabled ? 'disable-background' : ''
        }`}
      >
        <input
          id={`inputwithunit-input-${id}`}
          data-testid={id}
          className={`unit-box-input-text ${error ? 'input-error' : ''} ${
            isDisabled ? 'disable-element' : ''
          }`}
          type="text"
          onChange={onChange}
          value={inputValue}
        />
        <div
          id={`inputwithunit-input-unit-${unit}`}
          className={`gridlayer-label unit-background`}
        >
          {unit}
        </div>
      </div>
    </div>
  );
}

export default InputWithUnit;
